module.exports = __webpack_public_path__ + "img/German.813de28e.svg";